"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.MINOR = exports.buttonTypes = exports.DESTRUCTIVE = exports.PRIMARY = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
var MEDIUM = constants.size.MEDIUM;
exports.MEDIUM = MEDIUM;
var LARGE = constants.size.LARGE;
exports.LARGE = LARGE;
var PRIMARY = constants.kind.PRIMARY;
exports.PRIMARY = PRIMARY;
var DESTRUCTIVE = constants.kind.DESTRUCTIVE;
exports.DESTRUCTIVE = DESTRUCTIVE;
var buttonTypes = {
  ICON: "icon",
  RAW: "raw",
  SIMPLE: "simple"
};
exports.buttonTypes = buttonTypes;
var MINOR = constants.kind.MINOR;
exports.MINOR = MINOR;
//# sourceMappingURL=types.js.map